<header class="header-auto header-services">
    <div class="container-m h-100p">
      <div class="w-layout-grid grid _2er-header-services">
        <div id="w-node-a0f50413-bbcc-4efb-8d8e-682fa1efd391-e0a99293" class="grid-item t-r-50px">
          <div data-w-id="2a727ed9-1f2a-22f1-d986-1348a3973a96"  class="topline-wrapper b-30px">
            <div class="topline-line bg-primary"></div>
            <div class="text-topline text-background">Services</div>
          </div>
          <h1 data-w-id="a0f50413-bbcc-4efb-8d8e-682fa1efd392"  class="h1 text-background">find the right service for you</h1>
          <div class="content-wrapper max-80p t-50px">
            <p data-w-id="a0f50413-bbcc-4efb-8d8e-682fa1efd394"  class="text-normal text-background">We offer the full spectrum of services to help you achieve your goals. Whether you are looking to sell or rent your property, our team will make sure to provide you with the best guidance along the process. We are equipped with strong professionals that can assist you with residential sales and leasing, commercial sales and leasing, property management consultancy, holiday homes advisory, mortgage advisory, property evaluation advisory and property renovation advisory.<br><br></p>
          </div>
        </div>
        <div id="w-node-a0f50413-bbcc-4efb-8d8e-682fa1efd399-e0a99293" class="grid-item">
          <div class="image-wrapper-cut-right"><img class="image image-services-header-01" src="../../assets/images/EMAAR_DCHCentralPark_CGI03_06a.1.jpg" width="765" alt=""  sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 750px" data-w-id="a0f50413-bbcc-4efb-8d8e-682fa1efd39c" loading="lazy" srcset="../../assets/images/EMAAR_DCHCentralPark_CGI03_06a.1-p-500.jpeg 500w, ../../assets/images/EMAAR_DCHCentralPark_CGI03_06a.1-p-800.jpeg 800w, ../../assets/images/EMAAR_DCHCentralPark_CGI03_06a.1-p-1080.jpeg 1080w, ../../assets/images/EMAAR_DCHCentralPark_CGI03_06a.1.jpg 1400w"></div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-dark"><img src="../../assets/images/Gruppe-maskieren-88.svg" loading="lazy" alt="" class="image full-screen"></div>
  </header>
  <section class="section s-services-brands-30px">
    <div class="container-l">
      <div class="w-layout-grid grid _6er-brand">
        <div class="grid-item">
          <div class="brand-icon-wrapper"><img src="../../assets/images/Gruppe-maskieren-91.svg" loading="lazy" alt="" class="brand-icon"></div>
        </div>
        <div class="grid-item">
          <div class="brand-icon-wrapper"><img src="../../assets/images/Gruppe-maskieren-93.svg" loading="lazy" alt="" class="brand-icon"></div>
        </div>
        <div class="grid-item">
          <div class="brand-icon-wrapper"><img src="../../assets/images/Gruppe-maskieren-90.svg" loading="lazy" alt="" class="brand-icon"></div>
        </div>
        <div class="grid-item">
          <div class="brand-icon-wrapper"><img src="../../assets/images/Gruppe-maskieren-92.svg" loading="lazy" alt="" class="brand-icon"></div>
        </div>
        <div class="grid-item">
          <div class="brand-icon-wrapper"><img src="../../assets/images/Gruppe-maskieren-89_1.svg" loading="lazy" alt="" class="brand-icon"></div>
        </div>
        <div class="grid-item">
          <div class="brand-icon-wrapper"><img src="../../assets/images/Gruppe-maskieren-96.svg" loading="lazy" alt="" class="brand-icon"></div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-dark bg-line"></div>
  </section>
  <section class="section standard t-1px">
    <div class="container-l">
      <div data-w-id="fbff6aea-6894-c24f-112b-f7e50f189439"  class="w-layout-grid grid _2er-services-overview">
        <div class="grid-item">
          <div class="services-topline">01.</div>
          <a href="#Residential-Sales-Leasing" data-w-id="8a3aefa5-d469-a0b0-22fa-873b4d75e99b" class="servoces-link w-inline-block">
            <div>Residential Sales &amp; Leasing</div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
        <div class="grid-item">
          <div class="services-topline">02.</div>
          <a href="#Commercial-Sales-Leasing" data-w-id="c6bbf0df-b2e1-f14e-2e21-136e1999dcef" class="servoces-link w-inline-block">
            <div>Commercial Sales &amp; Leasing</div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
        <div class="grid-item">
          <div class="services-topline">03.</div>
          <a href="#Property-Management-Advisory" data-w-id="a64c0403-e7c0-8ae6-6dfe-53199183e007" class="servoces-link w-inline-block">
            <div>Property Management</div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
        <div class="grid-item">
          <div class="services-topline">04.</div>
          <a href="#Holiday-Homes-Advisory" data-w-id="41b3fc7d-bda1-3130-0798-6795791dcf2d" class="servoces-link w-inline-block">
            <div>Holiday Homes</div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
        <div class="grid-item">
          <div class="services-topline">05.</div>
          <a href="#Mortgage-Advisory" data-w-id="27e715a0-5d20-273e-a45c-73c5dc254368" class="servoces-link w-inline-block">
            <div>Mortgage CONSULTANCY</div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
        <div class="grid-item">
          <div class="services-topline">06.</div>
          <a href="#Property-Evaluation-Advisory" data-w-id="cbb67dfa-0817-8fbd-69fd-710c87cca603" class="servoces-link w-inline-block">
            <div>Property Evaluation</div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
        <div class="grid-item">
          <div class="services-topline">07.</div>
          <a href="#Property-Renovation-Advisory" data-w-id="425cb247-867c-3969-0430-e00032804f6b" class="servoces-link w-inline-block">
            <div>Property Renovation </div>
            <div class="services-line">
              <div class="services-line-inner"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="bg-section bg-dark bg-rounded-bottom"></div>
  </section>
  <section class="section standard">
    <div class="container-m">
      <div class="container-m">
        <div id="Residential-Sales-Leasing" class="orga">
          <div class="w-layout-grid grid _2er-c-normal">
            <div id="w-node-_54ceb0a3-5c0e-c086-3ce7-bf95caeb2834-e0a99293" class="grid-item">
              <div data-w-id="91666168-a8a2-2aa8-aef6-58ccc1dd1aaf"  class="image-wrapper"><img src="../../assets/images/BrandedApartments_Int_LivingRoom_V1.jpg" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt="" srcset="../../assets/images/BrandedApartments_Int_LivingRoom_V1-p-500.jpeg 500w, ../../assets/images/BrandedApartments_Int_LivingRoom_V1.jpg 800w" class="image-services"></div>
            </div>
            <div id="w-node-_54ceb0a3-5c0e-c086-3ce7-bf95caeb283f-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="390c7474-cc3e-701e-6198-4d96f46a9a12"  class="topline-wrapper b-20px">
                  <div class="text-topline">01.</div>
                </div>
                <h2 data-w-id="a2bb76df-e20e-d2eb-8d0f-2bb005acb693"  class="h3">Residential <br>Sales &amp; Leasing</h2>
                <p data-w-id="54ceb0a3-5c0e-c086-3ce7-bf95caeb2840"  class="text-normal">Our trained professionals will help you with all your queries. Whether you are looking to rent or sell a residence, we will work with you side by side with the help of our expertise to guide you throughout the entire process to provide the ideal solution for you. We will assist you with your goals and needs, providing you with an easy, safe, and satisfactory process.<br></p>
                <div data-w-id="54ceb0a3-5c0e-c086-3ce7-bf95caeb283c"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Commercial-Sales-Leasing" class="orga">
          <div class="w-layout-grid grid _2er-c-normal t-100px">
            <div id="w-node-_2dd2b571-a976-d88e-572c-0cb04b4ce6c7-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="2dd2b571-a976-d88e-572c-0cb04b4ce6c9"  class="topline-wrapper b-20px">
                  <div class="text-topline">02.</div>
                </div>
                <h2 data-w-id="2dd2b571-a976-d88e-572c-0cb04b4ce6cc"  class="h3">Commercial<br>Sales &amp; Leasing</h2>
                <p data-w-id="2dd2b571-a976-d88e-572c-0cb04b4ce6d0"  class="text-normal">Choosing the right commercial property is extremely important whether you want to start your own business or invest in a commercial property. <br>Our specialists can cater personalized services for you, providing the best solutions for your business and determining if the investment is profitable. <br></p>
                <div data-w-id="2dd2b571-a976-d88e-572c-0cb04b4ce6d5"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
            <div id="w-node-_2dd2b571-a976-d88e-572c-0cb04b4ce6d7-e0a99293" class="grid-item">
              <div data-w-id="2dd2b571-a976-d88e-572c-0cb04b4ce6d8"  class="image-wrapper"><img src="../../assets/images/LWKP_Plot27-02_CGI08_03.jpg" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt="" srcset="../../assets/images/LWKP_Plot27-02_CGI08_03-p-500.jpeg 500w, ../../assets/images/LWKP_Plot27-02_CGI08_03.jpg 800w" class="image-services"></div>
            </div>
          </div>
        </div>
        <div id="Property-Management-Advisory" class="orga">
          <div class="w-layout-grid grid _2er-c-normal t-100px">
            <div id="w-node-_237aa667-05b3-48ca-1576-6869b6cb0136-e0a99293" class="grid-item">
              <div data-w-id="237aa667-05b3-48ca-1576-6869b6cb0137"  class="image-wrapper"><img src="../../assets/images/LWKP_Plot27_02_CGI05_06.jpg" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt="" srcset="../../assets/images/LWKP_Plot27_02_CGI05_06-p-500.jpeg 500w, ../../assets/images/LWKP_Plot27_02_CGI05_06.jpg 800w" class="image-services"></div>
            </div>
            <div id="w-node-_237aa667-05b3-48ca-1576-6869b6cb0139-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="237aa667-05b3-48ca-1576-6869b6cb013b"  class="topline-wrapper b-20px">
                  <div class="text-topline">03.</div>
                </div>
                <h2 data-w-id="237aa667-05b3-48ca-1576-6869b6cb013e"  class="h3">Property <br>Management </h2>
                <p data-w-id="237aa667-05b3-48ca-1576-6869b6cb0142"  class="text-normal">Our experts will manage your property, taking care of every single detail. From finding prospective buyers to maintenance services, we will provide customized solutions with the flexibility to adapt to your needs. Grant us the chance to take care of your home. We will offer you more opportunities and less stress.<br></p>
                <div data-w-id="237aa667-05b3-48ca-1576-6869b6cb0147"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Holiday-Homes-Advisory" class="orga">
          <div class="w-layout-grid grid _2er-c-normal t-100px">
            <div id="w-node-d28582d3-a798-b1e6-a8c8-cf91128e1bea-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="d28582d3-a798-b1e6-a8c8-cf91128e1bec"  class="topline-wrapper b-20px">
                  <div class="text-topline">04.</div>
                </div>
                <h2 data-w-id="d28582d3-a798-b1e6-a8c8-cf91128e1bef"  class="h3">Holiday Homes<br></h2>
                <p data-w-id="d28582d3-a798-b1e6-a8c8-cf91128e1bf3"  class="text-normal">Explore the opportunity to capitalize on your home with Hudson Vacation Homes. Discover how much profit you could be earning by renting your properties. Our well-trusted team will take care of every aspect to assure you of the best results and solutions.<br></p>
                <div data-w-id="d28582d3-a798-b1e6-a8c8-cf91128e1bf8"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
            <div id="w-node-d28582d3-a798-b1e6-a8c8-cf91128e1bfa-e0a99293" class="grid-item">
              <div data-w-id="d28582d3-a798-b1e6-a8c8-cf91128e1bfb"  class="image-wrapper"><img src="../../assets/images/Bedroom2_edit_190323.jpg" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt="" srcset="../../assets/images/Bedroom2_edit_190323-p-500.jpeg 500w, ../../assets/images/Bedroom2_edit_190323.jpg 800w" class="image-services fit-left"></div>
            </div>
          </div>
        </div>
        <div id="Mortgage-Advisory" class="orga">
          <div class="w-layout-grid grid _2er-c-normal t-100px">
            <div id="w-node-d6921d08-2d4d-2191-acc6-22837c1180dc-e0a99293" class="grid-item">
              <div data-w-id="d6921d08-2d4d-2191-acc6-22837c1180dd"  class="image-wrapper"><img src="../../assets/images/DCH_Plot_2B_Hero_01.jpg" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt="" srcset="../../assets/images/DCH_Plot_2B_Hero_01-p-500.jpeg 500w, ../../assets/images/DCH_Plot_2B_Hero_01.jpg 800w" class="image-services"></div>
            </div>
            <div id="w-node-d6921d08-2d4d-2191-acc6-22837c1180df-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="d6921d08-2d4d-2191-acc6-22837c1180e1"  class="topline-wrapper b-20px">
                  <div class="text-topline">05.</div>
                </div>
                <h2 data-w-id="d6921d08-2d4d-2191-acc6-22837c1180e4"  class="h3">MORTGAGE CONSULTANCY</h2>
                <p data-w-id="d6921d08-2d4d-2191-acc6-22837c1180e8"  class="text-normal">Hudson will provide you with an easy and hassle-free experience. Our team of experts will advise what is suitable for you according to your necessities and requirements.<br></p>
                <div data-w-id="d6921d08-2d4d-2191-acc6-22837c1180ed"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Property-Evaluation-Advisory" class="orga">
          <div class="w-layout-grid grid _2er-c-normal t-100px">
            <div id="w-node-e4abfb94-2b39-3eae-5f67-a4c732a8713e-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="e4abfb94-2b39-3eae-5f67-a4c732a87140"  class="topline-wrapper b-20px">
                  <div class="text-topline">06.</div>
                </div>
                <h2 data-w-id="e4abfb94-2b39-3eae-5f67-a4c732a87143"  class="h3">Property <br>Evaluation </h2>
                <p data-w-id="e4abfb94-2b39-3eae-5f67-a4c732a87147"  class="text-normal">Our experienced team will help you evaluate your properties to minimize any risk. Hudson delivers sophisticated and accurate advice on the value of your property. We aim to provide transparency and professionalism in assessing your real estate portfolio.<br></p>
                <div data-w-id="e4abfb94-2b39-3eae-5f67-a4c732a8714c"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
            <div id="w-node-e4abfb94-2b39-3eae-5f67-a4c732a8713b-e0a99293" class="grid-item">
              <div data-w-id="e4abfb94-2b39-3eae-5f67-a4c732a8713c"  class="image-wrapper"><img src="../../assets/images/EMAAR_DCHVidaHotel_CGI02_03.jpg" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt="" srcset="../../assets/images/EMAAR_DCHVidaHotel_CGI02_03-p-500.jpeg 500w, ../../assets/images/EMAAR_DCHVidaHotel_CGI02_03.jpg 800w" class="image-services"></div>
            </div>
          </div>
        </div>
        <div id="Property-Renovation-Advisory" class="orga">
          <div class="w-layout-grid grid _2er-c-normal t-100px">
            <div id="w-node-b90a7d20-bac3-c3ff-30c0-406656792297-e0a99293" class="grid-item">
              <div data-w-id="b90a7d20-bac3-c3ff-30c0-406656792298"  class="image-wrapper"><img src="../../assets/images/190131_A2P_MKT2B_Bathroom_02.jpg" loading="lazy" width="742" alt="" class="image-services"></div>
            </div>
            <div id="w-node-b90a7d20-bac3-c3ff-30c0-406656792287-e0a99293" class="grid-item">
              <div class="content-wrapper">
                <div data-w-id="b90a7d20-bac3-c3ff-30c0-406656792289"  class="topline-wrapper b-20px">
                  <div class="text-topline">07.</div>
                </div>
                <h2 data-w-id="b90a7d20-bac3-c3ff-30c0-40665679228c"  class="h3">Property<br>Renovation </h2>
                <p data-w-id="b90a7d20-bac3-c3ff-30c0-406656792290"  class="text-normal">Renovating a property can always bring stress and doubts. Our experts will guide you to make the right selection guiding you from start to finish creating your new project. Projects of any scale are performed by our experienced team. We will create an entire project based on your needs, budget and preferences, pointing you in the right direction.<br></p>
                <div data-w-id="b90a7d20-bac3-c3ff-30c0-406656792295"  class="button-wrapper t-30px">
                  <a [routerLink]="['/contact']" class="button button-primary w-button">Get in touch</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard s-advantages">
    <div class="container-m">
      <div class="w-layout-grid grid _2er-advantages">
        <div class="grid-item">
          <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e655f5"  class="topline-wrapper b-30px">
            <div class="topline-line bg-primary"></div>
            <div class="text-topline text-background">Advantages</div>
          </div>
        </div>
        <div class="grid-item">
          <div class="content-wrapper">
            <h4 data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e655fb"  class="h3 text-background">DISCOVER THE ADVANTAGES OF WORKING WITH OUR TEAM OF EXPERTS</h4>
          </div>
        </div>
      </div>
      <div class="w-layout-grid grid _3er-advantages">
        <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e65600"  class="grid-item">
          <div class="content-wrapper">
            <div class="flex-wrapper">
              <div class="image-wrapper"><img src="../../assets/images/Gruppe-890.svg" loading="lazy" alt="" class="icon h-100px"></div>
              <div class="content-wrapper t-30px">
                <div class="topline-wrapper b-5px">
                  <div class="text-topline text-lighter">01.</div>
                </div>
                <h4 class="h-caps text-background">Lifestyle</h4>
                <div class="text-small text-background">We define ourselves not only as a real estate brokerage, but as a lifestyle manager. There are so many more needed factors to make our clients feel comfortable in their new home, and here at Hudson, we take care of that.</div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e6560d"  class="grid-item">
          <div class="content-wrapper">
            <div class="flex-wrapper">
              <div class="image-wrapper"><img src="../../assets/images/Gruppe-728.svg" loading="lazy" alt="" class="icon h-100px"></div>
              <div class="content-wrapper t-30px">
                <div class="topline-wrapper b-5px">
                  <div class="text-topline text-lighter">02.</div>
                </div>
                <h4 class="h-caps text-background">Maintenance</h4>
                <div class="text-small text-background">Along with our maintenance team, we will not just take care of your well being but also any type of installation for your future home will be handled professionally</div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e6561a"  class="grid-item">
          <div class="content-wrapper">
            <div class="flex-wrapper">
              <div class="image-wrapper"><img src="../../assets/images/Gruppe-889.svg" loading="lazy" alt="" class="icon h-100px"></div>
              <div class="content-wrapper t-30px">
                <div class="topline-wrapper b-5px">
                  <div class="text-topline text-lighter">03.</div>
                </div>
                <h4 class="h-caps text-background">DYNAMISM </h4>
                <div class="text-small text-background">We are a young and dynamic team where every client gets equally treated with respect and professionalism.</div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e65627"  class="grid-item">
          <div class="content-wrapper">
            <div class="flex-wrapper">
              <div class="image-wrapper"><img src="../../assets/images/Gruppe-734.svg" loading="lazy" alt="" class="icon h-100px"></div>
              <div class="content-wrapper t-30px">
                <div class="topline-wrapper b-5px">
                  <div class="text-topline text-lighter">04.</div>
                </div>
                <h4 class="h-caps text-background">Investment</h4>
                <div class="text-small text-background">If you are looking for properties as an investment, our team can give you access to highly sophisticated funding possibilities.</div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e65634"  class="grid-item">
          <div class="content-wrapper">
            <div class="flex-wrapper">
              <div class="image-wrapper"><img src="../../assets/images/Gruppe-888.svg" loading="lazy" alt="" class="icon h-100px"></div>
              <div class="content-wrapper t-30px">
                <div class="topline-wrapper b-5px">
                  <div class="text-topline text-lighter">05.</div>
                </div>
                <h4 class="h-caps text-background">Quality</h4>
                <div class="text-small text-background">We are only working with the best developers and landlords in town to ensure that we provide to our clients only the best quality properties.</div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="01cef8ff-f47c-6a26-4550-4ad5a4e65641"  class="grid-item">
          <div class="content-wrapper">
            <div class="flex-wrapper">
              <div class="image-wrapper"><img src="../../assets/images/Gruppe-887.svg" loading="lazy" alt="" class="icon h-100px"></div>
              <div class="content-wrapper t-30px">
                <div class="topline-wrapper b-5px">
                  <div class="text-topline text-lighter">06.</div>
                </div>
                <h4 class="h-caps text-background">Long-lasting relationships</h4>
                <div class="text-small text-background">At Hudson, we don’t strive for one-off sales since we aim to build up a long-lasting relationship with our clients. Whenever it comes to reselling, renting out, furnishing or renovating, we are the right team for you.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-dark bg-rounded"><img src="../../assets/images/bg-gs.svg" loading="lazy" alt="" class="image full-screen"></div>
  </section>
  <section data-w-id="5c7bd016-3756-e699-6c3a-a1a439938f81" class="section standard no-overflow">
    <div class="container-m">
      <div data-w-id="7b1a6947-e678-f8ca-2ec0-e2387805b893"  class="topline-wrapper b-50px">
        <div class="topline-line bg-primary"></div>
        <div class="text-topline text-default">Customer review</div>
      </div>
      <div class="w-layout-grid grid _2er-team-voices-l">
        <div id="w-node-a8de26ad-239b-07f0-088e-37a24fa0ea7c-e0a99293" class="grid-item">
          <div class="image-wrapper i-layers-left"><img src="../../assets/images/Gruppe-831_1.svg" loading="lazy" width="876"  alt="" data-w-id="a8de26ad-239b-07f0-088e-37a24fa0ea7e" class="image i-layer-01 meet-hudson-image-01"><img class="image i-layer-02 meet-hudson-image-02" src="../../assets/images/HUDSON-SERVICES.jpg" width="876" alt=""  sizes="(max-width: 767px) 100vw, 480px" data-w-id="a8de26ad-239b-07f0-088e-37a24fa0ea7f" loading="lazy" srcset="../../assets/images/HUDSON-SERVICES-p-500.jpg 500w, ../../assets/images/HUDSON-SERVICES-p-800.jpg 800w, ../../assets/images/HUDSON-SERVICES-p-1080.jpg 1080w, ../../assets/images/HUDSON-SERVICES-p-1600.jpg 1600w, ../../assets/images/HUDSON-SERVICES-p-2000.jpg 2000w, ../../assets/images/HUDSON-SERVICES-p-2600.jpg 2600w, ../../assets/images/HUDSON-SERVICES.jpg 3305w"></div>
        </div>
        <div id="w-node-a8de26ad-239b-07f0-088e-37a24fa0ea80-e0a99293" data-w-id="a8de26ad-239b-07f0-088e-37a24fa0ea80"  class="grid-item p1">
          <div class="icon-wrapper b-30px"><img src="../../assets/images/Pfad-4754.svg" loading="lazy" alt="" class="image icon-testimonial"></div>
          <h5 class="h4 weight-normal">I WOULD LIKE TO THANK ALL THE HUDSON TEAM FOR GOING ABOVE AND BEYOND. the process was easy and hassle-free. the team is always contactable and approachable, making the experience very pleasant.</h5>
          <div class="linie space-30px"></div>
          <div class="text-normal text-semibold">Louis Williams</div>
          <div class="text-small">Product Marketing Manager</div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-light"></div>
  </section>
  <section class="section standard t-0px">
    <div data-w-id="5c7bd016-3756-e699-6c3a-a1a439939031"  class="container-box bg-dark">
      <div class="container-m">
        <div class="content-wrapper">
          <h4 data-w-id="4a12f953-6c5b-6ec7-7c67-5425e3d2ebc8"  class="h2 l-center text-background">Book an <span class="text-span">appointment today</span></h4>
          <div class="content-wrapper max-60p l-center">
            <p data-w-id="4a12f953-6c5b-6ec7-7c67-5425e3d2ebcd"  class="text-normal l-center text-background">Register your interest and requirements today. Our agents will contact you as soon as possible to schedule a suitable timing to discuss your goals and needs.<br></p>
          </div>
          <div data-w-id="4a12f953-6c5b-6ec7-7c67-5425e3d2ebd0"  class="button-wrapper l-center t-30px">
            <a [routerLink]="['/contact']" class="button button-primary r-25px w-button">Book an appointment</a>
            <div class="button-wrapper-inner xs-t-20px">
              <a href="tel:+97145693115" class="button button-link button-line w-button">+971 4 380 5710</a>
            </div>
          </div>
        </div>
      </div><img src="../../assets/images/Gruppe-maskieren-78.svg" loading="lazy" alt="" class="image full-screen">
    </div>
    <div class="bg-section bg-light bg-rounded-bottom"></div>
  </section>